import QorusClient from "@/api/clients/QorusClient";
import Locales from "@/utils/locales";
import Uicookie from "@/utils/cookie";
import { AxiosRequestConfig } from "axios";

/**
 *  Qorus API about user's cart
 */


export default class PaymentService {
  public static config = {
    apiKey: process.env.VUE_APP_PSP_API_KEY,
    merchantAccount: process.env.VUE_APP_PSP_MERCHANT_ACCOUNT,
    clientKey: process.env.VUE_APP_PSP_CLIENT_KEY,
    environment: process.env.VUE_APP_PSP_ENVIRONMENT,
    returnUrl: process.env.VUE_APP_PSP_RETURNURL,
    origin: process.env.VUE_APP_PSP_ORIGIN,

  };

  static of(): PaymentService {
    return new PaymentService();
  }

  getIP(): string {
    return sessionStorage.getItem("ShopperIP") || "";
  }

  getPaymentMethods(amount): Promise<any> {
    const paymentParams = {
      shopperLocale: Locales.getLocaleCode(),
      merchantAccount: PaymentService.config.merchantAccount,
      amount: {
        value: amount.amount,
        currency: "EUR",
      },
      channel: "Web",
      countryCode: "FR",
    };

    return QorusClient.of().post("adyen/payment-methods", paymentParams).then(
      (data: any) => {

        return {
          response: data,
          clientKey: PaymentService.config.clientKey,
          environment: PaymentService.config.environment.toLowerCase(),
        };
      }, (data) => {
        throw data;
      },
    );
  }

  submitAdditionalDetails(data: any): Promise<any> {
    // logs the request
    // console.log("[payment] initiating payment: ", JSON.stringify(data, null, 2));
    // TODO: @cyril: je ne suis plus sûr si ça affiche le résultat bien formatté si on fait juste ", params" sans le JSON.stringify ?
    return QorusClient.of().post("adyen/submit-additional-details", data).then((data) => {
      //  console.log("[payment] payment initiated: ", JSON.stringify(data, null, 2));

      return data;
    }).catch((err) => {
      // console.log("[payment] payment failed: ", JSON.stringify(err, null, 2));
      throw err ? err.message : null;
    });
    // calls the API

    // logs the response
  }

  initiatePayment(data: any): Promise<any> {

    const shopperReference = data.user?.id;
    const shopperIp = this.getIP();
    const lineItems = data.cart.cartItems.map(item => {
      const offer = item.product.offer;

      return {
        description: item.product.reference,
        quantity: item.quantity,
        taxPercentage: (item.price.taxRate * 100) - 100,
        amountExcludingTax: item.price.taxFree * 100,
        id: offer.id,
        amountIncludingTax: item.price.taxIncluded * 100,
        taxAmount: item.price.taxAmount * 100,
      };
    });

    const paymentParams = {
      shopperStatement: "Air France Shopping",
      shopperLocale: Locales.getLocaleCode(),
      merchantAccount: PaymentService.config.merchantAccount,
      amount: {
        value: Math.round((data.cart.specialPrice.taxIncluded ? data.cart.specialPrice.taxIncluded : data.cart.totalPrice.taxIncluded) * 100),
        currency: "EUR",
      },
      origin: PaymentService.config.origin, // required for 3ds2 native flow
      browserInfo: data.data.browserInfo, // required for 3ds2
      channel: "Web",
      countryCode: "FR",
      reference: data.cart.uuid,
      paymentMethod: data.data.paymentMethod,
      returnUrl: PaymentService.config.returnUrl + "?cartUuid=" + data.cart.uuid,
      lineItems: lineItems,
      shopperIP: shopperIp, // required for 3ds2 native flow
      shopperReference: shopperReference,
      merchantOrderReference: data.cart.uuid,
      additionalData: {
        // RequestedTestAcquirerResponseCode: 4, // Uncomment to test different response codes
      },

    };

    return QorusClient.of().post("adyen/initiate-payment", paymentParams).then((data) => {
      return data;
    }).catch((err) => {
      throw err ? { error: err } : null;
    });

  }

  RetryOrderByUuid(shoppingCartUUID: string) {
    const userToken: string | null = Uicookie.getCustomerToken();

    if (userToken) {
      const axiosRequestConfig: AxiosRequestConfig = {
        headers: {
          "Customer-Authorization": userToken,
        },

      };
      return QorusClient.of().get("shopping-cart/payment-failed/" + shoppingCartUUID, axiosRequestConfig)
        .then(
          (data) => {
            return data;
          },
          (data) => {
            throw data;
          },
        );
    } else {
      Uicookie.error();
    }
  }

}